<template>
    <div
        id="pz-email_alert__frequency"
        class="pz-email_alert__frequency"
    >
        <!-- eslint-disable vue/no-mutating-props -->
        <ElSelect
            v-model="alertFrequency.frequency"
            class="pz-email_alert__select"
            popper-class="email-alert-create__frequency-popper"
            @change="changeFq"
        >
            <template #prefix>
                <PtIcon
                    icon="SolidDropdownOpen"
                    class="pz-email_alert__select-icon"
                />
            </template>
            <ElOption
                v-for="item in fqType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
        </ElSelect>
        <!-- eslint-disable vue/no-mutating-props -->
        <ElSelect
            v-if="alertFrequency.frequency !== 'D'"
            v-model="alertFrequency.date"
            class="pz-email_alert__select"
            popper-class="email-alert-create__frequency-popper"
        >
            <template #prefix>
                <PtIcon
                    icon="SolidDropdownOpen"
                    class="pz-email_alert__select-icon"
                />
            </template>
            <ElOption
                v-for="item in fqDates"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
        </ElSelect>
    </div>
</template>

<script>
import Select from 'element-ui/lib/select';
import Option from 'element-ui/lib/option';
import { map, clone } from 'lodash';
import Icon from '@patsnap-biz/icon';
import '@patsnap-ui/icon/assets/solid/DropdownOpen.svg';

export default {
    components: {
        PtIcon: Icon,
        ElSelect: Select,
        ElOption: Option,
    },
    model: {
        prop: 'alertFrequency',
        event: 'change',
    },
    props: {
        alertFrequency: {
            type: Object,
            default: () => {},
        },
        filterType: {
            type: String,
            default: '',
        },
        freqInitialType: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            default: () => ['W', 'D', 'M'],
        },
    },
    data() {
        const fqType = [
            {
                label: this.$t('emailAlertBiz.common.alertFrequency.weekly'),
                value: 'W',
            },
            {
                label: this.$t('emailAlertBiz.common.alertFrequency.everyday'),
                value: 'D',
            },
            {
                label: this.$t('emailAlertBiz.common.alertFrequency.monthly'),
                value: 'M',
            },
        ].filter((x) => this.options.indexOf(x.value) > -1);
        let fqDates = null;
        let weekdays = [];
        const dates = [];

        let emailAlertLang = this.$t('emailAlertBiz.common.alertFrequency.weekdays');
        if (!emailAlertLang || !(emailAlertLang instanceof Array)) {
            emailAlertLang = [];
        }
        weekdays = map(emailAlertLang, (label, index) => ({
            label,
            value: index,
        }));
        weekdays = weekdays.splice(1, weekdays.length - 1);
        fqDates = weekdays;
        // eslint-disable-next-line no-plusplus
        for (let i = 1; i <= 28; i++) {
            dates.push({
                label: this.$t('emailAlertBiz.common.alertFrequency.date', {
                    n: i,
                    // eslint-disable-next-line func-names
                    fix: (function (day) {
                        if (day > 3 && day < 19) return 'th';
                        switch (day % 10) {
                        case 1:
                            return 'st';
                        case 2:
                            return 'nd';
                        case 3:
                            return 'rd';
                        default:
                            return 'th';
                        }
                    }(i)),
                }),
                value: i,
            });
        }
        // 最后一日
        dates.push({
            label: this.$t('emailAlertBiz.common.alertFrequency.lastDay'),
            value: 29,
        });

        return {
            originFqType: clone(fqType),
            fqType,
            fqDates,
            dates,
            weekdays,
        };
    },
    watch: {
        filterType: {
            handler() {
                this.fqType = this.originFqType.filter(({ value }) => value !== this.filterType);
                if (this.alertFrequency.frequency === this.filterType) {
                    this.changeFq(this.fqType[0].value);
                }
            },
            immediate: true,
        },
        freqInitialType: {
            handler() {
                if (this.freqInitialType) {
                    this.changeFqDates(this.freqInitialType);
                }
            },
            immediate: true,
        },
    },
    created() {
        this.changeFqDates(this.alertFrequency.frequency);
    },
    methods: {
        changeFq(val) {
            this.changeFqDates(val);
            let date;
            if (this.fqDates) {
                date = this.fqDates[0].value;
            }
            this.$emit('change', {
                frequency: val,
                date,
            });
        },
        changeFqDates(type) {
            if (!type) return;
            switch (type) {
            case 'W':
                this.fqDates = this.weekdays;
                break;
            case 'M':
                this.fqDates = this.dates;
                break;
            default:
                this.fqDates = null;
            }
        },
    },
};
</script>
